<template>
    <a
        ref="gameCard"
        :href="game?.url?.relative"
        :data-game-id="game?.externalSystemId"
        :data-game-code="game?.codeName"
        class="games-card-game"
        :class="[variantClass, { 'game-launcher': !loading }, { 'games-card-game--skeleton': loading }]"
        :style="`--game-gradient-color: ${game?.gradientColor ?? '#000'}`"
    >
        <div v-if="showCard">
            <WebpVideo
                v-if="image"
                :src="image"
                :alt="`${props.game?.name} - obrázek`"
                css-class="games-card-game__img"
                :loop-video="true"
                :width="124"
                :height="140"
                :is-video-allowed="!isLowPerformance"
            />
            <JackpotIcon v-if="game.jackpotGuid" />
            <h3 class="games-card-game__text" v-html="game.name"></h3>
        </div>
    </a>
</template>

<script lang="ts" setup>
import { computed, onMounted, Ref, useTemplateRef } from "vue";
import { GamesCardGame } from "../models/game-card-game";
import { useBreakpoints } from "@sazka/utils/composables/use-breakpoints";
import { useGameEffects } from "../composables/use-game-effects";
import WebpVideo from "@sazka/design-system/src/video/webp-video.vue";
import JackpotIcon from "./jackpot-icon.vue";

export interface GameCardGameExpose {
    rootElement: Ref<HTMLElement>;
}

const props = withDefaults(
    defineProps<{
        game?: GamesCardGame;
        loading?: boolean;
        variant?: "default" | "square" | "double";
    }>(),
    {
        variant: "default",
    }
);

const isDesktop = useBreakpoints("sm2");
const isLowPerformance = environment.isLowPerformanceDevice;
const gameCard = useTemplateRef<HTMLElement>("gameCard");
const variantClass = props.variant ? "games-card-game--" + props.variant : null;

defineExpose<GameCardGameExpose>({
    rootElement: gameCard,
});

const image = computed(() => {
    return props.variant == "default" && props.game?.teaserImageVerticalUrl
        ? props.game?.teaserImageVerticalUrl
        : props.game?.teaserImageUrl;
});

const showCard = computed(() => !props.loading && props.game);

onMounted(async () => {
    if (isDesktop.value) {
        const { setupEffects } = useGameEffects([gameCard.value], () => isDesktop.value);
        setupEffects();
    }
});
</script>

<style lang="scss" scoped>
.v-enter-active,
.v-leave-active {
    transition: opacity 0.1s ease-in-out;
}

.v-enter-from,
.v-leave-to {
    opacity: 0;
}
</style>
